import { StationIndicators } from '@app/components/stations/StationIndicators';
import { Station } from '@mi-front/core';
import { Box } from '@mui/material';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { StationLabel } from './StationLabel';

interface Props {
  data: readonly Station[];
}

export const AdminStationsList = (props: Props) => {
  const { formatMessage } = useIntl();
  const { data } = props;

  return (
    <MrtTable
      navigateToOnClick={(id, row) => `/admin/stations/${row.slug}`}
      enableNavigateAction
      enableColumnFilters
      columnFilterDisplayMode="subheader"
      state={{
        showColumnFilters: true,
      }}
      columns={[
        {
          header: formatMessage({
            id: 'common.text.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableColumnFilter: true,
          muiFilterTextFieldProps: {
            sx: {
              maxWidth: '250px',
            },
          },
          Cell: ({ row: { original } }) => (
            <Box display="flex" alignItems="center" gap={1}>
              <StationLabel station={original} indicatorsDisplay={false} />
              <StationIndicators station={original} variant="chip" />
            </Box>
          ),
        },
      ]}
      data={[...data]}
    />
  );
};
